module.exports = __webpack_public_path__ + "static/media/iotrouter_white_logo.5bb7c1aa.png";